import axios from 'axios';
export function createCustomAxios(baseUrl) {
	//'https://testedu.drcnet.com.cn'
	window.$ChineseServerAddress = process.env.VUE_APP_BASE_CHINESE_API;
	const http = axios.create({
		baseURL: baseUrl ? baseUrl : $ChineseServerAddress + '/ckidfront', //挂载全局，mixins

		timeout: 300000,
	});

	http.all = axios.all;
	http.spread = axios.spread;

	http.ajaxGetCode = function (url, params) {
		return http.get(url, { params }).then((res) => res);
	};

	http.ajaxPostCode = function (url, params) {
		return http.post(url, params).then((res) => res);
	};

	http.ajaxpostExport = function (url, data, fileName, type) {
		return http
			.post(url, data, {
				responseType: 'blob',
			})
			.then((result) => {
				const filename = decodeURI(`${fileName}.${type}`);
				const blob = new Blob([result.data]);
				const url = window.URL.createObjectURL(blob);
				const link = document.createElement('a');
				link.style.display = 'none';
				link.href = url;
				link.setAttribute('download', filename);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
				window.URL.revokeObjectURL(url);
			});
	};

	return http;
}

export default createCustomAxios;
